import firebase from "firebase/app"
import "firebase/auth"
import "firebase/database"
import "firebase/storage"
import "firebase/firestore"
import "firebase/functions"

/*import admin from "firebase-admin" 
import functions from "firebase-functions";*/

const prodConfig = {
  apiKey: "AIzaSyAWdq4o3HqDMwp7Pg7KXZ9I2NqOidqiy1w",
  authDomain: "hydra-securityprod.firebaseapp.com",
  databaseURL: "https://hydra-securityprod.firebaseio.com",
  projectId: "hydra-securityprod",
  storageBucket: "hydra-securityprod.appspot.com",
  messagingSenderId: "181041556618",
  appId: "1:181041556618:web:b507e2ab7db683d7d05173"
}

const devConfig = {
  apiKey: "AIzaSyDD9-qaawHZ1EkQT3Bbifdnhz_l7A6f3oM",
  authDomain: "hydra-security.firebaseapp.com",
  databaseURL: "https://hydra-security.firebaseio.com",
  projectId: "hydra-security",
  storageBucket: "hydra-security.appspot.com",
  messagingSenderId: "377084884325",
  appId: "1:377084884325:web:b80da8952d6ed6c38d5d8c"
};
//production
//development
const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}
//const firestore = firebase.firestore();
//const settings = { /* your settings... */ timestampsInSnapshots: true };
//firestore.settings(settings);
/*With this change, timestamps stored in Cloud Firestore will be read back as
Firebase Timestamp objects instead of as system Date objects*/

const db = firebase.database()
const fs = firebase.firestore()
const auth = firebase.auth()
const store = firebase.storage()
const googleProvider = new firebase.auth.GoogleAuthProvider()

/*
exports.createUser = functions.firestore
  .document("users/{userId}")
  .onCreate((snap, context) => {
    // Get an object representing the document
    // e.g. {'name': 'Marie', 'age': 66}
    const newValue = snap.data();

    // access a particular field as you would any JS property
    const name = newValue.name;
    console.log(newValue, name, "firestore functions");
    // perform desired operations ...
  });*/

export { db, auth, fs, store, googleProvider, firebase }
